import { render, staticRenderFns } from "./CubeShadow.vue?vue&type=template&id=ef827a82&scoped=true&"
import script from "./CubeShadow.vue?vue&type=script&lang=js&"
export * from "./CubeShadow.vue?vue&type=script&lang=js&"
import style0 from "./CubeShadow.vue?vue&type=style&index=0&id=ef827a82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef827a82",
  null
  
)

export default component.exports